import { useActiveProject } from "@/features/project/ActiveProject";
import { ProjectStages } from "@/features/project/projectTopSection/stages/ProjectStages";
import { ProjectProgress } from "@/features/projects/cards/ProjectProgress";
import { useSettings } from "@repo/ui";
import isEmpty from "lodash/isEmpty";

import { ProjectHeader } from "./ProjectHeader";

export const ProjectTopSection = () => {
  const { project_stages } = useSettings();
  const { opportunity } = useActiveProject();

  const showStages =
    project_stages?.enable &&
    (isEmpty(project_stages?.hfb)
      ? true
      : opportunity?.hfb?.some((hfb) =>
          project_stages?.hfb?.some(
            (hfbConfig) => hfbConfig.hfb_code_key === hfb
          )
        ));

  return (
    <>
      <ProjectHeader />
      {showStages ? (
        <ProjectStages />
      ) : (
        <ProjectProgress
          opportunity={opportunity}
          editable={!opportunity?.lockStatus}
        />
      )}
    </>
  );
};
